/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ title: NonNullable<unknown> }} Mobile_Paste_Text_Preview_TitleInputs */

const en_mobile_paste_text_preview_title = /** @type {(inputs: Mobile_Paste_Text_Preview_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Audio title: ${i?.title}`)
};

const es_mobile_paste_text_preview_title = /** @type {(inputs: Mobile_Paste_Text_Preview_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Título del audio: ${i?.title}`)
};

/**
* | output |
* | --- |
* | "Audio title: {title}" |
*
* @param {Mobile_Paste_Text_Preview_TitleInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_paste_text_preview_title = /** @type {((inputs: Mobile_Paste_Text_Preview_TitleInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Paste_Text_Preview_TitleInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_paste_text_preview_title(inputs)
	return en_mobile_paste_text_preview_title(inputs)
});